// 设备指纹生成工具
export const generateDeviceFingerprint = () => {
  const components = [];
  
  // 1. User Agent
  components.push(navigator.userAgent);
  
  // 2. 屏幕分辨率
  components.push(`${screen.width}x${screen.height}x${screen.colorDepth}`);
  
  // 3. 时区
  components.push(new Date().getTimezoneOffset());
  
  // 4. 语言
  components.push(navigator.language);
  
  // 5. 平台
  components.push(navigator.platform);
  
  // 6. CPU核心数
  components.push(navigator.hardwareConcurrency || 'unknown');
  
  // 7. 设备内存
  components.push(navigator.deviceMemory || 'unknown');
  
  // 8. Canvas指纹
  try {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    ctx.textBaseline = 'top';
    ctx.font = '14px Arial';
    ctx.fillText('Device Fingerprint', 2, 2);
    components.push(canvas.toDataURL());
  } catch (e) {
    components.push('canvas-error');
  }
  
  // 生成哈希
  const fingerprint = components.join('|');
  return simpleHash(fingerprint);
};

// 简单哈希函数
const simpleHash = (str) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash;
  }
  return Math.abs(hash).toString(36);
};
